import { logger } from '@modules/logger';
import { createContext } from 'react';

interface PopoverContextValues {
  show: boolean;
  onPositionDepsChange: () => void;
}
const PopoverContext = createContext<PopoverContextValues>({
  show: false,
  onPositionDepsChange: () => logger.warn('onPositionDepsChange has not been implemented for PopoverContext'),
});

export { PopoverContext };
